import React from 'react';
import './Admin.css';
import Sidebar from "../components/Sidebar";

function Admin() {
    return (
        <div className="admin">
            <Sidebar />
            {/* <Dashboard /> */}
        </div>
    )
}

export default Admin
